export const SMVM_SET_PRIVATE_NOTE_REQUEST = "SMVM_SET_PRIVATE_NOTE_REQUEST";
export const SMVM_SET_PRIVATE_NOTE_SUCCESS = "SMVM_SET_PRIVATE_NOTE_SUCCESS";
export const SMVM_SET_PRIVATE_NOTE_FAIL = "SMVM_SET_PRIVATE_NOTE_FAIL";
export const SMVM_SET_PRIVATE_NOTE_RESET = "SMVM_SET_PRIVATE_NOTE_RESET";

export const SMVM_GET_PRIVATE_NOTE_REQUEST = "SMVM_GET_PRIVATE_NOTE_REQUEST";
export const SMVM_GET_PRIVATE_NOTE_SUCCESS = "SMVM_GET_PRIVATE_NOTE_SUCCESS";
export const SMVM_GET_PRIVATE_NOTE_FAIL = "SMVM_GET_PRIVATE_NOTE_FAIL";
export const SMVM_GET_PRIVATE_NOTE_RESET = "SMVM_GET_PRIVATE_NOTE_RESET";
